<template>
  <div>
    <div v-if="$has('FWS-KJSH-SKTK-TGBH') && [1, '1'].includes(current.approvalStatus)">
      <el-button
        class="table-button table-button-success"
        icon="el-icon-success"
        @click="handleOperateState(1, current)"
      >通过</el-button>

      <el-button
        class="table-button table-button-danger"
        icon="el-icon-delete-solid"
        @click="handleOperateState(2, current)"
      >驳回</el-button>
    </div>
    <!-- 确认/取消确认弹窗 -->
    <operate-dialog
      :visible.sync="isOperateStateShow"
      :data-obj.sync="refundObj"
      :text-config.sync="textConfig"
      :loading="submitLoading"
      @submit="setRefundApproval"
    />
  </div>
</template>

<script>
import { setRefundApproval, setRefundBatchApproval } from '@/api/approval/refund';

export default {
  props: {
    current: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: '1',
    },
  },
  data() {
    return {
      refundObj: {}, // 退款审核对象
      textConfig: {}, // 弹窗页面提示文案
      isOperateStateShow: false, // 确认/驳回弹窗
      submitLoading: false,
    };
  },
  computed: {
    paymentStr() {
      return this.type === '1' ? '发起退款' : '发起付款';
    },
    againPaymentStr() {
      return this.type === '1' ? '再次退款' : '再次付款';
    },
  },
  methods: {
    /**
     * 退款审核 确认/驳回
     * refundNo     退款审核编号
     * operation     操作：1、确认 2、驳回
     * cancelRemark  驳回原因，驳回时传入
    */
    handleOperateState(operation, row) {
      this.refundObj = {
        refundNo: row?.refundNo || '',
        operation,
        cancelRemark: '',
      };
      const list = {
        1: {
          title: '审核通过确认',
          messageTip: '是否通过该笔退款申请？',
          isPass: true,
        },
        2: {
          title: '审核驳回',
          messageTip: '驳回原因',
          isPass: false,
          required: true,
        },
      };
      this.textConfig = list[operation] || '-';
      this.isOperateStateShow = true;
    },
    // 退款审核列表-退款批量审核操作+退款审核操作请求接口
    async setRefundApproval(params) {
      try {
        this.submitLoading = true;
        if (this.textConfig?.isBatch) { // 批量
          await setRefundBatchApproval(params);
        } else {
          await setRefundApproval(params);
        }
        this.$message({
          message: '操作成功！',
          type: 'success',
        });
        this.submitLoading = false;
        this.isOperateStateShow = false;
        this.$emit('success');
      } catch (error) {
        console.log(error);
        this.submitLoading = false;
      }
    },
  },
};
</script>
